import {
  Flex,
  Input,
  Label,
  Modal,
  Button,
  Card,
  styled,
  toast
} from '@fareye/ui'
import { cancelToken, post, put } from '@fareye/utils'
import { cloneDeep, isEmpty } from 'lodash'
import React, { useRef } from 'react'
import { DEVICE_CONFIG } from '../../../config/constants'
const CustomLabel = styled(Label)`
  margin-bottom: 5px;
`
const CustomInput = styled.input`
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(179, 179, 179);
  border-radius: 4px;
  padding: 9px 13px;
  font-size: 16px;
  background: transparent;
  outline: none;
`

export default function DeviceModal({
  setSelectedDevice,
  selectedDevice,
  setDevices,
  consigners = []
}: any) {
  const { data } = selectedDevice
  console.log(data)
  const imeiRef = useRef<HTMLInputElement>(null)
  const simRef = useRef<HTMLInputElement>(null)
  const vehicleNoRef = useRef<HTMLInputElement>(null)
  const source = cancelToken().source()
  const { devices:deviceUrl } = DEVICE_CONFIG
  const isScrapedRef = useRef<HTMLInputElement>(null)
  const scrapedReasonRef = useRef<HTMLInputElement>(null)
  const consignerRef = useRef<HTMLInputElement>(null)

  const handleSubmit = async () => {
    const imei = imeiRef?.current?.value
    const sim = simRef?.current?.value
    const vehicleNo = vehicleNoRef.current?.value
    const isScraped = isScrapedRef?.current?.checked || false
    const scrapedReason = scrapedReasonRef?.current?.value || ''
    const consignerValue = consignerRef?.current?.value || ''
    const consignerId = Number(consignerValue.split('-')[0]) || null
    if (imei && sim && vehicleNo && consignerId) {
      const devices = {
        IMEI: imei,
        GSM_phone_number: sim,
        vehicle_no: vehicleNo,
        is_scraped: isScraped,
        scraped_reason: scrapedReason,
        consigner_id: consignerId
      }
      let url = ''
      if (isEmpty(selectedDevice.data)) {
        url += `${deviceUrl}`
        try {
          const {
            data: { data }
          } = await post(url, { devices }, source.token)
          setSelectedDevice({ ...selectedDevice, openEditModal: false })
          setDevices((devices: any) => {
            const deviceClone = cloneDeep(devices)
            deviceClone.data.push({
              ...data,
              imei,
              gsmPhoneNumber: sim,
              vehicleNo,
              is_scraped: isScraped,
              scraped_reason: scrapedReason,
              consigner_id: consignerId
            })
            return deviceClone
          })
          toast.success('Device mapping added successfully')
        } catch (ex) {
          console.log(ex)
        }
      } else {
        url += `${deviceUrl}/${selectedDevice.data.imei}`
        try {
          const {
            data: { data }
          } = await put(url, { devices }, source.token)
          setSelectedDevice({ ...selectedDevice, openEditModal: false })
          setDevices((devices: any) => {
            const deviceClone = cloneDeep(devices)
            const index = deviceClone.data.findIndex(
              (obj: any) => obj.imei === imei
            )
            let device = deviceClone.data[index]

            if (device) {
              // Modify the property of the found object
              device = {
                ...data,
                imei,
                gsmPhoneNumber: sim,
                vehicleNo,
                is_scraped: isScraped,
                scraped_reason: scrapedReason,
                consigner_id: consignerId
              }
              deviceClone.data[index] = device
            } else {
              console.log('Object not found')
            }
            return deviceClone
          })
          toast.success('Device mapping updated successfully')
        } catch (ex) {
          console.log(ex)
        }
      }
    }
  }

  return (
    <Modal
      style={{
        content: {
          width: '25vw'
        }
      }}
      variant="s"
      toggleModal={selectedDevice.openEditModal}
      setToggleModal={value => {
        setSelectedDevice({
          ...selectedDevice,
          openEditModal: value,
          data: null
        })
      }}
    >
      <Card
        bodyStyle={{
          display: 'grid',
          gap: '15px'
        }}
      >
        <Label style={{ marginTop: '-15px' }} variant="h4">
          Add Device
        </Label>
        <Flex column>
          <CustomLabel>IMEI</CustomLabel>
          <CustomInput
            disabled={data?.imei ? true : false}
            defaultValue={data?.imei}
            ref={imeiRef}
            type="text"
          />
        </Flex>
        <Flex column>
          <CustomLabel>Gsm Sim Number</CustomLabel>
          <CustomInput
            defaultValue={data?.gsmPhoneNumber}
            ref={simRef}
            type="text"
          />
        </Flex>
        <Flex column>
          <CustomLabel>Vehicle No</CustomLabel>
          <CustomInput
            defaultValue={data?.vehicleNo}
            ref={vehicleNoRef}
            type="text"
          />

        </Flex>
        <Flex column>
          <CustomLabel>Select Consigner</CustomLabel>
          <CustomInput
            defaultValue={
              data?.consignerId
                ? `${data.consignerId} - ${
                    consigners.find((c: any) => c.id === data.consignerId)?.consignerCode
                  }`
                : ''
            }
            list="consigner-list"
            ref={consignerRef}
          />

          <datalist id="consigner-list">
            {consigners?.map((item: any) => (
              <option key={item.id} value={`${item.id} - ${item.consignerCode}`}>
              </option>
            ))}
          </datalist>
        </Flex>

        <Flex column>
          <CustomLabel>Scraped Reason</CustomLabel>
          <CustomInput
            defaultValue={data?.scrapedReason || ''}
            ref={scrapedReasonRef}
            type="text"
          />
        </Flex>
        <Flex alignItemsCenter>
          <input
            type="checkbox"
            id="isScraped"
            ref={isScrapedRef}
            defaultChecked={data?.isScraped || false}
          />
          <label htmlFor="isScraped"> Is Scraped</label>
        </Flex>
        <Flex justifyContentFlexEnd p={1}>
          <Button
            variant="m danger"
            onClick={() =>
              setSelectedDevice({
                ...selectedDevice,
                openEditModal: false,
                data: null
              })
            }
          >
            Cancel
          </Button>
          <Button
            variant="m primary"
            style={{ marginLeft: 10 }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Flex>
      </Card>
    </Modal>
  )
}
